import { Box } from '@chakra-ui/react'

import type { UserDetails } from '@/components/Worlds/types'

import AvatarPopover from './AvatarPopover'
import AvatarWithName, { type AvatarWithNameProps } from './AvatarWithName'

export default function AvatarWithNameAndPopover(
  props: AvatarWithNameProps & {
    user: Pick<
      UserDetails,
      | 'id'
      | 'displayName'
      | 'avatarUrl'
      | 'activeAnniversary'
      | 'collegeInfo'
      | 'roles'
      | 'pronouns'
      | 'bio'
      | 'username'
      | 'timezone'
      | 'keyClubDistrictName'
    >
  }
): JSX.Element {
  const { user, world, worldLevel } = props

  return (
    <AvatarPopover
      user={user}
      worldSlug={world != null ? world.slug : null}
      worldLevel={worldLevel ?? null}
    >
      <Box>
        <AvatarWithName {...props} />
      </Box>
    </AvatarPopover>
  )
}
